import { render, staticRenderFns } from "./versionUpdatingModal.vue?vue&type=template&id=f15d5478&scoped=true&"
import script from "./versionUpdatingModal.vue?vue&type=script&lang=js&"
export * from "./versionUpdatingModal.vue?vue&type=script&lang=js&"
import style0 from "./versionUpdatingModal.vue?vue&type=style&index=0&id=f15d5478&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15d5478",
  null
  
)

export default component.exports